import { render, staticRenderFns } from "./ApprovalView.vue?vue&type=template&id=539ee57c&scoped=true&"
import script from "./ApprovalView.vue?vue&type=script&lang=js&"
export * from "./ApprovalView.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalView.vue?vue&type=style&index=0&id=539ee57c&scoped=true&lang=css&"
import style1 from "./ApprovalView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ee57c",
  null
  
)

export default component.exports